const fileTypes = {
	json: "json",
	csv: "csv"
}

export default fileTypes
